import { useState, useEffect } from 'react'

import { http } from '@itau-loans-www/services'
import { goTo } from '@itau-loans-www/utils'

export const usePendingData = () => {
  const [proposal, setProposal] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [isAlertVisible, setIsAlertVisible] = useState(true)
  const [initialValuesFromApi, setInitialValuesFromApi] = useState({})

  const closeAlert = () => setIsAlertVisible(false)

  useEffect(() => {
    if (!proposal) {
      http.proposal
        .getPendingData()
        .then(({ simulation, form_data }) => {
          setProposal(simulation)
          setInitialValuesFromApi(form_data)
        })
        .catch(() => {
          goTo('final-screen-error-proposal')
        })
        .finally(() => {
          setIsLoading(false)
        })
    }
  }, [proposal])

  const handleSendProposal = (event, requestBody) => {
    // TO DO: testar integracão com o back
    event.preventDefault()
    setSubmitLoading(true)
    http.proposal
      .putPendingData(requestBody)
      .then(({ final_screen }) => goTo(final_screen))
      .catch(() => {
        goTo('final-screen-error-proposal')
      })
      .finally(() => setSubmitLoading(false))
  }

  return {
    proposal,
    isLoading,
    closeAlert,
    isAlertVisible,
    handleSendProposal,
    initialValuesFromApi,
    submitLoading
  }
}
